import React from "react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker } from "react-icons/hi";
import Section from "./Section";
import Reveal from "./Reveal";
import { profile } from "../data";

function Contact() {
  const items = [
    [<HiOutlineMail />, profile.email, `mailto:${profile.email}`],
    [<HiOutlinePhone />, profile.phone, `tel:${profile.phone.replace(/\s/g, "")}`],
    [<AiFillGithub />, "github.com/AhmedSaleemKhan", profile.github],
    [<FaLinkedinIn />, "linkedin.com/in/ahmed-saleem-khan", profile.linkedin],
    [<HiOutlineLocationMarker />, profile.location, null],
  ];
  return (
    <Section id="contact" title="Let's" accent="Connect">
      <div className="contact-grid">
        {items.map(([icon, text, href], i) => {
          const Tag = href ? "a" : "div";
          const props = href ? { href, target: href.startsWith("http") ? "_blank" : undefined, rel: "noreferrer" } : {};
          return (
            <Reveal key={i} delay={i * 80}>
              <Tag className="card contact-item" {...props}>
                <span className="contact-icon">{icon}</span>
                <span>{text}</span>
              </Tag>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}

export default Contact;
